'use client';
import React from 'react';
import { ImageObj } from '@custom-types/ImageObj.types';
import { Box, Stack } from '@mui/material';
import CustomImage from '@components/CustomImage';
import SplideSlider from '@components/SplideSlider';
import { ArrowLeftIcon, ArrowRightIcon } from '@components/SVGIcon/Icons';
import cn from './style.module.scss';
interface WimbledonBridgeDataProps {
  type: 'living' | 'bedroom' | 'kitchen' | 'bathroom';
  tabDescription: string;
  images: Array<ImageObj>;
}
export default function WimbledonBridgeData(props: WimbledonBridgeDataProps) {
  const { type, tabDescription, images } = props;
  const tabTypeClass = type && cn[type] ? cn[type] : '';
  const wimbledonBridgeDataSettings = {
    type: 'loop',
    rewind: false,
    pagination: true,
    arrows: true,
    autoplay: false,
    speed: 2000,
    gap: '0',
    interval: 3000,
    padding: {
      right: '15%',
      left: '0',
    },
    breakpoints: {
      768: {
        gap: '10px',
        padding: {
          right: '60px',
        },
      },
    },
  };
  return (
    <Stack className={cn.wimbledonBridgeData}>
      <Box className={cn.wimbledonBridgeDataInner}>
        <Box component="picture" className={cn.wimbledonBridgeDataTheme}>
          {images?.length > 1 ? (
            <SplideSlider
              showArrows
              arrowsClassName={cn.wimbledonBridgeArrows}
              prevClassName={cn.wimbledonBridgeArrowsPrev}
              nextClassName={cn.wimbledonBridgeArrowsNext}
              slideClassName={cn.wimbledonBridgeSlide}
              activeSlideClassName={cn.wimbledonBridgeActiveSlide}
              prevArrow={<ArrowLeftIcon />}
              nextArrow={<ArrowRightIcon />}
              options={wimbledonBridgeDataSettings}
            >
              {images.map((imgObj, index) => (
                <Box
                  className={`${cn.wimbledonThemeElement} ${cn[`wimbledonBridge__${type}`]}`}
                  key={`${imgObj.name}_${index}`}
                  role="img"
                  aria-label={imgObj.alt || imgObj.name}
                >
                  <CustomImage
                    src={imgObj.url}
                    alt={imgObj.alt}
                    width={768}
                    height={768}
                  />
                </Box>
              ))}
            </SplideSlider>
          ) : (
            images?.length > 0 && (
              <Box
                className={`${cn.wimbledonThemeElement} ${cn[`wimbledonBridge__${type}`]}`}
              >
                <CustomImage
                  src={images[0]?.url}
                  alt={images[0]?.alt}
                  width={768}
                  height={768}
                />
              </Box>
            )
          )}
        </Box>
      </Box>
    </Stack>
  );
}
